import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import Link from 'react-router/lib/Link';

import Icon from '../../../Icon';
import styles from './index.styl';

const PlaceholderCard = ({ counter, text, route }) => (
  <li styleName="card">
    <Link to={route}>
      <div styleName="wrapper wrapper--placeholder">
        <div styleName="header" />
        <div styleName="image">
          <span>{counter}</span>
        </div>
        <div styleName="link">
          {text}
          <Icon className="ml2" name="icon-arrow-left" height={10} width={18} />
        </div>
      </div>
    </Link>
  </li>
);

PlaceholderCard.propTypes = {
  counter: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
};

export default CSSModules(PlaceholderCard, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Communities/Components/VerticalCard/PlaceholderCard.jsx